require('./bootstrap');

import angular from "angular";
import angularAnimate from "angular-animate";
import angularTouch from "angular-touch";
import angularSanitize from "angular-sanitize";
import uiBootstrap from "angular1-ui-bootstrap4";
import notify from "@cgross/angular-notify";
import ngFileUpload from "ng-file-upload";
import textAngular from "textangular"
import angularUiMask from "angular-ui-mask"
import angularMoment from "angular-moment";
import angularFilter from "angular-filter";
import angularScroll from "angular-scroll";

require('videogular/dist/videogular/videogular');
require('videogular-controls/vg-controls');
require('videogular-overlay-play/vg-overlay-play');
require('videogular-poster/vg-poster');
require('videogular-buffering/vg-buffering');
require('videogular-quality/vg-quality/');
require('dashjs/dist/dash.all.min');
require('videogular-dash/vg-dash');

require('./angular_locale_ru');

require('angular-chart.js');

angular
    .module('app', [
        angularAnimate,
        angularTouch,
        angularSanitize,
        uiBootstrap,
        ngFileUpload,
        notify,
        textAngular,
        angularUiMask,
        angularMoment,
        angularFilter,
        angularScroll,
        'chart.js',
        'com.2fdevs.videogular',
        'com.2fdevs.videogular.plugins.controls',
        'com.2fdevs.videogular.plugins.overlayplay',
        'com.2fdevs.videogular.plugins.dash',
        'com.2fdevs.videogular.plugins.buffering',
        'th.co.softever.videogular.plugins.quality'
    ])
    .config(['$provide', function ($provide) {

        $provide.decorator('taOptions', ['taRegisterTool', '$uibModal', '$delegate', function (taRegisterTool, $uibModal, taOptions) {

            taOptions.toolbar = [
                ['h3'],
                ['bold', 'italics', 'underline', 'ul', 'ol'],
                ['justifyLeft', 'justifyCenter', 'justifyRight'],
                ['insertLink'],
                ['insertTable']
            ];

            taOptions.forceTextAngularSanitize = false;

            // taRegisterTool('insertTable', {
            //     iconclass: "fa fa-table",
            //     action: function (deferred) {
            //         var textAngular = this
            //         $uibModal.open({
            //             size: 'lg',
            //             component: 'textAngularTableInsert',
            //         }).result.then(function (result) {
            //                 textAngular.$editor().wrapSelection('inserthtml', result.table, true)
            //             },
            //             function () {
            //                 deferred.resolve()
            //             }
            //         );
            //         return false;
            //     },
            // });
        //
        // taRegisterTool('uploadImage', {
        //     buttontext: 'Upload Image',
        //     iconclass: "fa fa-image",
        //     action: function (deferred, restoreSelection) {
        //         console.log('test');
        //         $uibModal
        //             .open({
        //                 component: 'uploadImage'
        //             })
        //             .result
        //             .then(
        //                 function (res) {
        //                     restoreSelection();
        //                     document.execCommand('insertImage', true, res);
        //                     deferred.resolve();
        //                 },
        //                 function () {
        //                     deferred.resolve();
        //                 }
        //             );
        //         return false;
        //     }
        // });
        //
        // taOptions.toolbar[1].push('uploadImage');

        return taOptions;
    }]);

}])
.
config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}])
    .run(['$templateCache', function ($templateCache) {

        $templateCache.put('auth-modal-template.html', '<div class="modal-dialog modal-auth-form" uib-modal-transclude></div>');

        $templateCache.put("uib/template/pagination/pagination.html",
            "<li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"page-item pagination-first\"><a href class=\"page-link\" ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle><i class=\"fas fa-arrow-circle-left\"></i></a></li>\n" +
            "<li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"page-item pagination-prev\"><a href class=\"page-link\" ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle><i class=\"fas fa-arrow-left\"></i></a></li>\n" +
            "<li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"page-item pagination-page\"><a href class=\"page-link\" ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
            "<li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"page-item pagination-next\"><a href class=\"page-link\" ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle><i class=\"fas fa-arrow-right\"></i></a></li>\n" +
            "<li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"page-item pagination-last\"><a href class=\"page-link\" ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle><i class=\"fas fa-arrow-circle-right\"></i></a></li>\n" +
            "");

        $templateCache.put(
            'vertical-centered-modal.html',
            "<div class=\"modal-dialog modal-dialog-centered {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n"
        );
        $templateCache.put("vg-templates/vg-quality-selector",
            '<ul><li ng-repeat="o in qualities track by $index" ng-class="{\'active\':currentQuality === o}" ng-click="changeQuality(o)">{{ o.name }}</li></ul>');
    }]);

require('./controllers/main.controller');

require('./filters/translate');
require('./filters/get-by-lang');

require('./services/auth');
require('./services/notifier');
require('./services/error-response-parser');
require('./services/trans');
require('./services/requestsQueue');

require('./components/users-control/users-control');
require('./components/user-create-form/user-create-form');
require('./components/user-update-form/user-update-form');
require('./components/users-import/users-import');


require('./components/roles-control/roles-control');
require('./components/role-form/role-form');
require('./components/permissions-control/permissions-control');
require('./components/permission-form/permission-form');
require('./components/user-roles/user-roles');
require('./components/user-permissions/user-permissions');
require('./components/module-form/module-form');
require('./components/roles-and-permissions/roles-and-permissions');

require('./components/courses-control/courses-control');
require('./components/course-form/course-form');
require('./components/course-create-form/course-create-form');
require('./components/course-extra-info/course-extra-info');
require('./components/course-lessons/course-lessons');
require('./components/course-training/course-training');
require('./components/course-checkout-form/course-checkout-form');
require('./components/course-signup-form/course-signup-form');
require('./components/course-page/course-page');
require('./components/course-video-preview/course-video-preview');
require('./components/course-answers/course-answers');
require('./components/course-chapters-modal/course-chapters-modal');
require('./components/course-review/course-review');
require('./components/course-review-with-reply/course-review-with-reply');

require('./components/active-groups-control/active-groups-control');
require('./components/active-students-control/active-students-control');

require('./components/reviews-control/reviews-control');
require('./components/review-reply-form/review-reply-form');

require('./components/course-group-form/course-group-form');
require('./components/users-select-modal/users-select-modal');


require('./components/categories-control/categories-control');
require('./components/category-form/category-form');


require('./components/chapter-form/chapter-form');
require('./components/lecture-form/lecture-form');
require('./components/lesson-form-main/lesson-form-main');
require('./components/lesson-form-task/lesson-form-task');
require('./components/lesson-create-form/lesson-create-form');
require('./components/lesson-chapter-form/lesson-chapter-form');

require('./components/file-upload-modal/file-upload-modal');

require('./components/category-image-select/category-image-select');

require('./components/upload-image/upload-image');


require('./components/task-form/task-form');

require('./components/recaptcha-form/recaptcha-form');

require('./components/delete-form/delete-form');
require('./components/delete-lesson-modal/delete-lesson-modal');
require('./components/course-delete-modal/course-delete-modal');


require('./components/cabinet-user-profile/cabinet-user-profile');
require('./components/cabinet-user-courses/cabinet-user-courses');
require('./components/cabinet-user-history/cabinet-user-history');
require('./components/cabinet-user-notifications/cabinet-user-notifications');

require('./components/home-page/home-page');

require('./components/videos-control/videos-control');
require('./components/videos-upload-modal/videos-upload-modal');
require('./components/video-select-modal/video-select-modal');
require('./components/video-form/video-form');

require('./components/header-component/header-component');

require('./components/auth-modal/auth-modal');
require('./components/login-form/login-form');
require('./components/register-form/register-form');
require('./components/reset-password-form/reset-password-form');


require('./components/orders-control/orders-control');

require('./components/video-card/video-card');
require('./components/video-modal-player/video-modal-player');
require('./components/vimeo-video-modal/vimeo-video-modal');

require('./components/payment-info/payment-info');

require('./components/user-courses-list/user-courses-list');

require('./components/task-answer/task-answer');
require('./components/user-answer-modal/user-answer-modal');

require('./components/task-answers-control/task-answers-control');
require('./components/task-answer-form/task-answer-form');
require('./components/notification-form/notification-form');

require('./components/lesson-comments/lesson-comments');

require('./components/free-sign-up/free-sign-up');

require('./components/demo-sign-up/demo-sign-up');

require('./components/videogular-player/videogular-player');

require('./components/comment-form/comment-form');
require('./components/comment-reply-form/comment-reply-form');

require('./components/comments-control/comments-control');

require('./components/user-search/user-search');
require('./components/comment-detail/comment-detail');


require('./components/course-group-students/course-group-students');
require('./components/course-group-students-attach-modal/course-group-students-attach-modal');
require('./components/course-group-lessons/course-group-lessons');


require('./components/group-create-form/group-create-form');
require('./components/group-students-control/group-students-control');
require('./components/group-students-attach-modal/group-students-attach-modal');
require('./components/group-lessons-control/group-lessons-control');
require('./components/group-settings/group-settings');

require('./components/single-course-form/single-course-form');
require('./components/attached-students-modal/attached-students-modal');
require('./components/group-curriculum-control/group-curriculum-control');
require('./components/course-training-lesson-error/course-training-lesson-error');


require('./components/individual-students-control/individual-students-control');
require('./components/individual-course-settings/individual-course-settings');
require('./components/individual-course-demo/individual-course-demo');
require('./components/individual-attach-students/individual-attach-students');
require('./components/individual-confirm-students-attach-modal/individual-confirm-students-attach-modal');
require('./components/individual-student-attach/individual-student-attach');

require('./components/course-groups-and-students/course-groups-and-students');
require('./components/course-training-program/course-training-program');
require('./components/course-training-program-mobile/course-training-program-mobile');
require('./components/course-buy-confirm/course-buy-confirm');
require('./components/course-priority-modal/course-priority-modal');

require('./components/group-import-students-modal/group-import-students-modal');

require('./components/import-user-form/import-user-form');

require('./components/user-course-control/user-course-control');
require('./components/mobizon-messages-control/mobizon-messages-control');

require('./components/user-devices-list/user-devices-list');

require('./components/social-links-control/social-links-control');
require('./components/social-links-form/social-links-form');
require('./components/users-online/users-online');

require('./components/main-chart/main-chart');

require('./components/group-import-students-register-new/group-import-students-register-new');

require('./components/new-course-lessons/new-course-lessons');
require('./components/lesson-form-file/lesson-form-file');
require('./components/notification-direct-reply-for-comment/notification-direct-reply-for-comment');
require('./components/notification-indirect-reply-for-comment/notification-indirect-reply-for-comment');
require('./components/notification-task-rejected/notification-task-rejected');
require('./components/notification-task-accepted/notification-task-accepted');
require('./components/notification-course-move-to-archive/notification-course-move-to-archive');
require('./components/notification-lesson-available/notification-lesson-available');
require('./components/notification-reply-for-review/notification-reply-for-review');
require('./components/notification-course-resumed/notification-course-resumed');
require('./components/notification-course-started/notification-course-started');
require('./components/notification-new-lesson-added/notification-new-lesson-added');
require('./components/you-tube-modal/you-tube-modal');
require('./components/parameters-control/parameters-control');

require('./components/course-lessons-automatization-page-restricted/course-lessons-automatization-page-restricted');
require('./components/message-more-details/message-more-details');

require('./components/group-automatization-settings/group-automatization-settings');
require('./components/group-automatization-settings-not-found/group-automatization-settings-not-found');
require('./components/individual-course-automatization-settings/individual-course-automatization-settings');
require('./components/lesson-form-quiz/lesson-form-quiz');
require('./components/question-form/question-form');
require('./components/quiz-pass-page/quiz-pass-page');
require('./components/quiz-results-control/quiz-results-control');
require('./components/quiz-result-page/quiz-result-page');
require('./components/quiz-result-admin-page/quiz-result-admin-page');

require('./components/test-component/test-component');

require('./components/upload-audio/upload-audio');
require('./components/text-angular-table-insert/text-angular-table-insert');
require('./components/mobizon-card-admin-main/mobizon-card-admin-main');
require('./components/individual-import-students-modal/individual-import-students-modal');
require('./components/boom-stream-modal/boom-stream-modal');
require('./components/boom-stream-live-modal/boom-stream-live-modal');
require('./components/packets-control/packets-control');
require('./components/packet-create-modal/packet-create-modal');
require('./components/packet-form/packet-form');
require('./components/packet-import-students-modal/packet-import-students-modal');
require('./components/packet-students-attach-modal/packet-students-attach-modal');
require('./components/course-experts/course-experts');
require('./components/expert-attach-modal/expert-attach-modal');

require('./components/user-delete-form/user-delete-form')